import { getCompanyPageMeta, lunarYear } from '@/utils/seoHelper';
import Head from 'next/head';
import React from 'react';

interface CompanyPageMetaHeaderProps {
  branchPage: any,
  path: string;
}

const CompanyPageMetaHeader: React.FC<CompanyPageMetaHeaderProps> = ({ branchPage, path }) => (
  <Head>
    <title>{`[GIẢM 20K] Đặt mua vé máy bay ${branchPage?.name} giá rẻ với nhiều mã khuyến mãi | Goyolo.com`}</title>
    <meta
      name="description"
      content={getCompanyPageMeta(branchPage?.name)}
    />
    <meta
      name="google-site-verification"
      content={process.env.NEXT_PUBLIC_GOOGLE_SITE_VERIFICATION}
    />
    <meta
      name="og:type"
      property="og:type"
      content="Product"
    />
    <meta
      name="og:title"
      property="og:title"
      content={`[GIẢM 20K] Đặt mua vé máy bay ${branchPage?.name} giá rẻ, với nhiều mã khuyến mãi tại Goyolo.com`}
    />
    <meta
      name="og:description"
      property="og:description"
      content={`Vé máy bay ${branchPage?.name} giá rẻ với nhiều khuyến mãi tại Goyolo.com, vé đã bao gốm thuế phí của hãng bay, tra cứu lịch bay và hotline ${branchPage?.name} dễ dàng, ${branchPage?.name} mở bán vé Tết ${lunarYear}.`}
    />
    <meta
      name="og:image"
      property="og:image"
      content={process.env.NEXT_PUBLIC_LOGO_LINK}
    />
    <meta
      name="og:image:alt"
      property="og:image:alt"
      content={`Goyolo.com săn vé máy bay ${branchPage?.name} giá rẻ`}
    />
    <meta
      name="og:locale"
      property="og:locale"
      content="vi"
    />
    <meta
      name="og:url"
      property="og:url"
      content={path}
    />
    <meta
      name="og:site_name"
      property="og:site_name"
      content="Goyolo.com"
    />
    <meta
      name="fb:app_id"
      property="fb:app_id"
      content="https://www.facebook.com/Goyolocom-103117924769137"
    />
    <link
      rel="alternate"
      type="text/html"
      href={path}
      hrefLang="x-default"
      title="Tiếng Việt"
    />
    <link
      rel="canonical"
      href={path}
    />
  </Head>
);

export default CompanyPageMetaHeader;
